import cameraTools from '../sketchfab/camera'
import screenshot from '../sketchfab/screenshot'
import materialTools from '../sketchfab/materials'
import sceneTools from '../sketchfab/scene'
import environmentTools from '../sketchfab/environment'
import postprocessingTools from '../sketchfab/postprocessing'
import store from '../../store'

const SetVisibilitySingle = function (isVisible, names, matchNameExactly) {
  for (let name of names) {
    if (isVisible) {
      sceneTools.show(name, matchNameExactly)
    } else {
      sceneTools.hide(name, matchNameExactly)
    }
  }
}

const SetVisibilityGroup = function (group, option) {
  // first, hide all options from this group
  for (let options of group.options) {
    SetVisibilitySingle(false, options.objects, false)
  }
  // Then, show the picked option
  SetVisibilitySingle(true, option.objects, false)
}

async function _SetSingleMaterialOption (sceneMaterialName, baseMaterialName, materialPayload) {
  let state = store.getters['materialList/getState']
  let sceneMaterial = materialTools.getSceneMaterial(sceneMaterialName)
  let baseMaterial = state.basematerials.find(mtl => mtl.name === baseMaterialName)
  if (sceneMaterial && baseMaterial.payload && materialPayload) {
    // first "reset" the material with the base settings, then apply the
    // material settings. Finally, push the material back to the sketchfab scene
    // We need to await to make sure uploaded textures are ready before setting the material
    await materialTools.setMaterialChannelsOptions(sceneMaterial, baseMaterial.payload)
    await materialTools.setMaterialChannelsOptions(sceneMaterial, materialPayload)
    materialTools.setMaterial(sceneMaterial)
  }
}

const SetMaterialOption = function (material, option) {
  if (material.type === null || material.type === 'single') {
    _SetSingleMaterialOption(material.scenematerial, option.basematerial, option.payload)
  }
  if (material.type === 'colorway') {
    for (let mtOption of option.options) {
      _SetSingleMaterialOption(mtOption.scenematerial, mtOption.basematerial, mtOption.payload)
    }
  }
}

const SetPostProcessing = function () {
  let state = store.getters['postprocessing/getState']

  if (state.postprocessing !== undefined) {
    let basePostprocessing = state.basepostprocessing.find(pp => pp.name === state.postprocessing.basename)
    if (basePostprocessing === undefined) { basePostprocessing = {} }

    // merge the basepost and scenepost together
    const post = Object.assign({}, basePostprocessing.payload, state.postprocessing.payload)
    postprocessingTools.setPostProcessing(post)
  }
}

const SetBackground = function () {
  let state = store.getters['background/getState']
  if (state.background !== undefined) {
    let basebackground = state.basebackground.find(pp => pp.name === state.background.basename)
    if (basebackground === undefined) { basebackground = {} }
    // merge the basepost and scenepost together
    const theBackground = Object.assign({}, basebackground.payload, state.background.payload)
    environmentTools.setBackground(theBackground)
  }
}

const SetEnvironment = function (payload) {
  let state = store.getters['environment/getState']
  if (state.environment !== undefined) {
    let baseEnvironment = state.baseenvironment.find(pp => pp.name === state.environment.basename)
    if (baseEnvironment === undefined) { baseEnvironment = {} }
    // merge the basepost and scenepost together
    const env = Object.assign({}, baseEnvironment.payload, state.environment.payload, payload)
    environmentTools.setEnvironment(env)
  }
}

const setView = function (viewItem) {
  cameraTools.setCameraLookAt(viewItem.eye, viewItem.lookat, 1)
}

const setState = function (stateItem) {
  if (stateItem.basedon !== undefined) {
    setState(stateItem.basedon)
  }

  if (stateItem.visibility !== undefined) {
    for (let item of stateItem.visibility) {
      let visibilityItem = store.getters['visibilitySingleList/getItemByProperty']('name', item.name)
      SetVisibilitySingle(item.option, visibilityItem.objects, true)
    }
  }

  if (stateItem.material !== undefined) {
    for (let item of stateItem.material) {
      let materialGroup = store.getters['materialList/getItemByProperty']('name', item.name)
      let materialOption = materialGroup.options.find(m => m.title === item.option)
      SetMaterialOption(materialGroup.scenematerial, materialOption.basematerial, materialOption.payload)
    }
  }
}

const getScreenshot = function (callback) {
  screenshot.getScreenShot(640, 480, callback)
}

window.configuratorapi.SetSingleMaterialOption = _SetSingleMaterialOption

export default {
  SetMaterialOption,
  SetVisibilitySingle,
  SetVisibilityGroup,
  setView,
  setState,
  getScreenshot,
  SetPostProcessing,
  SetEnvironment,
  SetBackground
}
